/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @type {Array} The array filled with two-part transition words.
 */
export default [ [ "buď", "nebo" ], [ "buď", "anebo" ], [ "ani", "ani" ], [ "nejen", "ale i" ], [ "jak", "tak" ],
	[ "sice", "ale" ], [ "sice", "však" ], [ "jednak", "jednak" ] ];
